const PLAYWIRE_SPA_NAVIGATION_FLAG = "__playwireSpaHasNavigated";

type PlaywireWindow = Window & {
  [PLAYWIRE_SPA_NAVIGATION_FLAG]?: boolean;
};

function getPlaywireWindow(): PlaywireWindow | null {
  if (typeof window === "undefined") {
    return null;
  }

  return window as PlaywireWindow;
}

export function markPlaywireSpaNavigation() {
  const playwireWindow = getPlaywireWindow();

  if (!playwireWindow) {
    return;
  }

  playwireWindow[PLAYWIRE_SPA_NAVIGATION_FLAG] = true;
}

export function shouldCountPlaywirePageview() {
  const playwireWindow = getPlaywireWindow();

  return Boolean(playwireWindow?.[PLAYWIRE_SPA_NAVIGATION_FLAG]);
}
